(() => {
  'use strict';

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  const loadSecondaryImage = (event) => {
    if (!canHover.matches) return;

    const card = event.target.closest('[data-product-card]');
    const template = card?.querySelector('[data-secondary-image-template]');
    if (!template || template.dataset.loading) return;
    template.dataset.loading = 'true';

    const image = template.content.firstElementChild?.cloneNode(true);
    if (!image) {
      template.remove();
      return;
    }

    const revealImage = () => {
      card.classList.add('is-secondary-loaded');
      template.remove();
    };

    image.addEventListener('load', revealImage, { once: true });
    image.addEventListener('error', () => {
      image.remove();
      template.remove();
    }, { once: true });
    template.before(image);
    if (image.complete && image.naturalWidth > 0) revealImage();
  };

  document.addEventListener('pointerover', loadSecondaryImage, { passive: true });
  document.addEventListener('focusin', loadSecondaryImage);
})();
